import Link from "next/link";
import { useTranslations } from "next-intl";

import type { DownloadComponent } from "@/lib/api/formatting/rorosTweed/productPage";

import ProductAccordion from "../ProductAccordion";
import styles from "./downloads.module.scss";

const Downloads = (download?: DownloadComponent) => {
  const t = useTranslations();
  return (
    <>
      {download?.downloadLink && (
        <ProductAccordion title={t("downloads")}>
          <p className={styles.text}>
            {t("exploreOurImageBankToDownloadImagesFor")}:
          </p>
          <Link href={download.downloadLink} legacyBehavior>
            <div>
              <span className={styles.link}>{download.label}</span>
              <span
                className={`${styles.text} ${styles.parenthetical}`}
              >{`(${download.parenthetical})`}</span>
            </div>
          </Link>
        </ProductAccordion>
      )}
    </>
  );
};

export default Downloads;
